import React, { Component } from 'react'
import styled from 'styled-components'

import ButtonOutlineV2 from '../ButtonOutlineV2'
import ButtonGradientV2 from '../ButtonGradientV2'
import BigModalV2 from '../BigModalV2'

import IcNetwork from './images/ic-network.component.svg'
import IcElectricGas from './images/ic-eletricity-gas.component.svg'
import IcServices from './images/ic-support.component.svg'
import IcDiscounts from './images/ic-discounts.component.svg'
import IcTaxes from './images/ic-taxes.component.svg'
import IcResult from './images/ic-result.component.svg'
import IcCheck from './images/ic-check.component.svg'
import Loading from 'components/Loading'

import { pricesCurrency, currency } from 'utils'

import {
  TITLES,
  MERCHANT_IDENTIFICATION,
  COMERCIAL_CONDITIONS,
  ADDITIONAL_SERVICES,
  REFUNDS_ENTRIES,
} from './information-entries'

import {
  processIdentification,
  processComercial,
  processAdditionalServices,
  processRefunds,
} from './processor'

export default class DetailsModalV2 extends Component {
  state = {
    tab: 'general',
  }

  toggleTab = (value) => {
    this.setState({ tab: value })
  }

  renderRow = (field, name, isPrice = false, suffix = '', fallback = '') => {
    const suffixElement = suffix ? <span>{suffix}</span> : null

    return field ? (
      <Row>
        <ContentCell light={true}>{name}</ContentCell>
        <ContentCell suffix={suffix}>
          {isPrice ? pricesCurrency(field) : field} {suffixElement}
        </ContentCell>
      </Row>
    ) : fallback ? (
      <Row>
        <ContentCell light={true}>{name}</ContentCell>
        <ContentCell>{fallback}</ContentCell>
      </Row>
    ) : null
  }

  renderIdentificationLabels = (identification, entry) => {
    let value = identification[entry] ? identification[entry] : '-'

    if (entry === 'website_contact') {
      value = identification.website_contact
        ? identification.website_contact
        : identification.email_contact
        ? identification.email_contact
        : '---'
    } else if (entry === 'email_contact') {
      return null
    }

    let content = value
    if (
      entry === 'commercial_offer_website' ||
      entry === 'website_standardized_contract_form' ||
      entry === 'website_contract_conditions' ||
      (entry === 'website_contact' && identification.website_contact)
    ) {
      content = (
        <Link href={value} target='_blank' rel='noopener noreferrer'>
          {value}
        </Link>
      )
    }

    return (
      <Row key={`identification_entry_${entry}`}>
        <ContentCell light={true}>{MERCHANT_IDENTIFICATION[entry]}</ContentCell>
        <ContentCell>{content}</ContentCell>
      </Row>
    )
  }

  renderGeneralLabels = (identification, entry, LABELS) => {
    let value = identification[entry]
      ? identification[entry] === true
        ? 'Sim'
        : identification[entry]
      : identification[entry] === false
      ? 'Não'
      : '-'

    return (
      <Row key={`general_entry_${entry}`}>
        <ContentCell light={true}>{LABELS[entry]}</ContentCell>
        <ContentCell>{value}</ContentCell>
      </Row>
    )
  }

  renderGeneralTable = () => {
    const tariff = this.props.tariff.result
    const timeCycle = tariff.priceListTimeCycle
    const tariffInfo = this.props.tariffInfo

    return this.state.tab === 'general' && tariff ? (
      <TableBody>
        {tariff.electricityPriceList && (
          <Row>
            <TitleCell>Eletricidade</TitleCell>
          </Row>
        )}
        {tariff.electricityPriceList
          ? this.renderRow(
              tariff.prices.electricity.termo_fixo,
              'Termo Potência*',
              true,
              '€/Dia'
            )
          : null}
        {tariff.electricityPriceList && timeCycle === 's'
          ? this.renderRow(
              tariff.prices.electricity.cheia,
              'Energia*',
              true,
              '€/kWh'
            )
          : null}
        {tariff.electricityPriceList && timeCycle !== 's'
          ? this.renderRow(
              tariff.prices.electricity.vazio,
              'Vazio*',
              true,
              '€/kWh'
            )
          : null}
        {tariff.electricityPriceList && timeCycle === 'b'
          ? this.renderRow(
              tariff.prices.electricity.cheia,
              'Fora do Vazio*',
              true,
              '€/kWh'
            )
          : null}
        {tariff.electricityPriceList && timeCycle !== 's' && timeCycle !== 'b'
          ? this.renderRow(
              tariff.prices.electricity.ponta,
              'Ponta*',
              true,
              '€/kWh'
            )
          : null}
        {tariff.electricityPriceList && timeCycle !== 's' && timeCycle !== 'b'
          ? this.renderRow(
              tariff.prices.electricity.cheia,
              'Cheias*',
              true,
              '€/kWh'
            )
          : null}

        {tariff.electricityPriceList && (
          <Row>
            <ContentCell light={true}>Tarifário</ContentCell>
            <ContentCell suffix>
              {timeCycle === 's'
                ? 'Simples'
                : timeCycle === 'b'
                ? 'Bi-Horário'
                : 'Tri-Horário'}
            </ContentCell>
          </Row>
        )}

        {tariff.gasPriceList && (
          <Row>
            <TitleCell>Gás Natural</TitleCell>
          </Row>
        )}
        {tariff.gasPriceList &&
          this.renderRow(
            tariff.prices.gas.termo_fixo,
            'Termo Fixo*',
            true,
            '€/Dia'
          )}
        {tariff.gasPriceList &&
          this.renderRow(
            tariff.prices.gas.termo_energia,
            'Energia*',
            true,
            '€/kWh'
          )}
        {tariff.gasPriceList &&
          this.renderRow(tariff.gasStage, 'Escalão', false)}

        {tariffInfo.additional_services.length ? (
          <Row>
            <TitleCell>Ofertas Comerciais</TitleCell>
          </Row>
        ) : null}
        {tariffInfo.additional_services.length ? (
          <AdditionalServicesRow>
            <div className='content'>
              {tariffInfo.additional_services.map((item, index) => (
                <span key={`additional_service_${index}_${item}`}>
                  <IcCheck />
                  {item.name}
                </span>
              ))}
            </div>
          </AdditionalServicesRow>
        ) : null}
      </TableBody>
    ) : null
  }

  renderInvoicingTable = () => {
    const tariff = this.props.tariff.result
    const suffix = <span>€</span>

    const eleAnnualFixedTerm = tariff.electricityFixedTerm
      ? Number(tariff.electricityFixedTerm)
      : 0
    const gasAnnualFixedTerm = tariff.gasFixedTerm
      ? Number(tariff.gasFixedTerm)
      : 0
    const monthlyNetworkAccess = (eleAnnualFixedTerm + gasAnnualFixedTerm) / 12

    const eleAnnualEnergy = tariff.electricityEnergy
      ? Number(tariff.electricityEnergy)
      : 0
    const gasAnnualEnergy = tariff.gasEnergy ? Number(tariff.gasEnergy) : 0
    const monthlyEnergy = (eleAnnualEnergy + gasAnnualEnergy) / 12

    return this.state.tab === 'invoicing' ? (
      <TableBody>
        {tariff.electricityPriceList && (
          <Row>
            <TitleCell>Eletricidade</TitleCell>
          </Row>
        )}
        {tariff.electricityPriceList && (
          <Row>
            <InvoiceCell light={true}>Termo Potência*</InvoiceCell>
            <ContentCell suffix>
              {currency(tariff.electricityFixedTerm / 12)}
              {suffix}
            </ContentCell>
          </Row>
        )}
        {tariff.electricityPriceList && (
          <Row>
            <InvoiceCell light={true}>Custo de Energia*</InvoiceCell>
            <ContentCell suffix>
              {currency(tariff.electricityEnergy / 12)}
              {suffix}
            </ContentCell>
          </Row>
        )}

        {tariff.gasPriceList && (
          <Row>
            <TitleCell>Gás Natural</TitleCell>
          </Row>
        )}
        {tariff.gasPriceList && (
          <Row>
            <InvoiceCell light={true}>Termo Fixo*</InvoiceCell>
            <ContentCell suffix>
              {currency(tariff.gasFixedTerm / 12)}
              {suffix}
            </ContentCell>
          </Row>
        )}
        {tariff.gasPriceList && (
          <Row>
            <InvoiceCell light={true}>Custo de Energia*</InvoiceCell>
            <ContentCell suffix>
              {currency(tariff.gasEnergy / 12)}
              {suffix}
            </ContentCell>
          </Row>
        )}

        <Row>
          <TitleCell>Detalhes</TitleCell>
        </Row>
        <Row>
          <InvoiceCell light={true}>
            <IcNetwork />
            Potência
          </InvoiceCell>
          <ContentCell suffix>
            {monthlyNetworkAccess.toFixed(2).replace('.', ',')}
            {suffix}
          </ContentCell>
        </Row>
        <Row>
          <InvoiceCell light={true}>
            <IcElectricGas />
            Energia
          </InvoiceCell>
          <ContentCell suffix>
            {monthlyEnergy.toFixed(2).replace('.', ',')}
            {suffix}
          </ContentCell>
        </Row>
        <Row>
          <InvoiceCell light={true}>
            <IcServices /> Outros Serviços
          </InvoiceCell>
          <ContentCell suffix>
            {currency(tariff.additionalServicesCost / 12)}
            {suffix}
          </ContentCell>
        </Row>
        <Row>
          <InvoiceCell light={true}>
            <IcDiscounts /> Reembolsos/Descontos
          </InvoiceCell>
          <ContentCell suffix>
            {currency(tariff.annualRefunds / 12)}
            {suffix}
          </ContentCell>
        </Row>
        <Row>
          <InvoiceCell light={true}>
            <IcTaxes /> Taxas e Impostos
          </InvoiceCell>
          <ContentCell suffix>
            {currency(tariff.annualTaxes / 12)}
            {suffix}
          </ContentCell>
        </Row>
        <Row>
          <InvoiceCell light={true}>
            <IcResult /> Valor Mensal
          </InvoiceCell>
          <ContentCell suffix>
            {currency(tariff.annualBilling / 12)}
            {suffix}
          </ContentCell>
        </Row>
      </TableBody>
    ) : null
  }

  renderMoreInfoTable = () => {
    const tariffInfo = this.props.tariffInfo
    const additionalInfo = tariffInfo.pricelistadditionalinfo

    const identification = processIdentification(tariffInfo, additionalInfo)
    const comercial = processComercial(tariffInfo, additionalInfo)
    const additionalServices = processAdditionalServices(
      tariffInfo,
      additionalInfo
    )
    const refunds = processRefunds(additionalInfo)

    return this.state.tab === 'moreInfo' && tariffInfo ? (
      <TableBody>
        <Row>
          <TitleCell>{TITLES.IDENTIFICATION}</TitleCell>
        </Row>
        {Object.keys(identification).map((entry) =>
          this.renderIdentificationLabels(identification, entry)
        )}

        <Row>
          <TitleCell>{TITLES.COMERCIAL_CONDITIONS}</TitleCell>
        </Row>
        {Object.keys(comercial).map((entry) =>
          this.renderGeneralLabels(comercial, entry, COMERCIAL_CONDITIONS)
        )}

        <Row>
          <TitleCell>{TITLES.ADDITIONAL_SERVICES}</TitleCell>
        </Row>
        {Object.keys(additionalServices).map((entry) =>
          this.renderGeneralLabels(
            additionalServices,
            entry,
            ADDITIONAL_SERVICES
          )
        )}

        <Row>
          <TitleCell>{TITLES.REFUNDS}</TitleCell>
        </Row>
        {Object.keys(refunds).map((entry) =>
          this.renderGeneralLabels(refunds, entry, REFUNDS_ENTRIES)
        )}
      </TableBody>
    ) : null
  }

  renderWarningText = () => {
    const { tab } = this.state

    return tab === 'general' || tab === 'invoicing' ? (
      <WarningText>* Os preços inluem a tarifa de acesso às redes.</WarningText>
    ) : null
  }

  renderBtns = () => {
    const { hasBtns, onClose, tariff, onJoin } = this.props

    return hasBtns ? (
      <ButtonsRow>
        <ButtonOutlineV2 style={{ width: '115px' }} onClick={onClose}>
          Cancelar
        </ButtonOutlineV2>
        <ButtonGradientV2
          style={{ width: '115px' }}
          onClick={() => onJoin(tariff)}>
          Aderir
        </ButtonGradientV2>
      </ButtonsRow>
    ) : null
  }

  render() {
    const { title, onClose, tariffInfo, loading, ...restProps } = this.props
    const { tab } = this.state

    return (
      <BigModalV2
        modalTriggerHeight={this.props.modalTriggerHeight}
        setModalTriggerHeight={this.props.setModalTriggerHeight}
        style={{ width: '750px' }}
        title='Detalhes do tarifário'
        onClose={onClose}>
        <Wrapper {...restProps}>
          <Content>
            <TableHeader>
              <TopRow>
                <ToggleButton
                  active={tab === 'general'}
                  onClick={() => this.toggleTab('general')}>
                  Preços e Condições
                </ToggleButton>
                <ToggleButton
                  active={tab === 'invoicing'}
                  onClick={() => this.toggleTab('invoicing')}>
                  Fatura Mensal Estimada
                </ToggleButton>
                <ToggleButton
                  active={tab === 'moreInfo'}
                  onClick={() => this.toggleTab('moreInfo')}>
                  Informação Geral
                </ToggleButton>
              </TopRow>
            </TableHeader>
            {!tariffInfo && loading && <Loading />}
            {tariffInfo && this.renderGeneralTable()}
            {this.renderInvoicingTable()}
            {tariffInfo && this.renderMoreInfoTable()}
            {this.renderWarningText()}
          </Content>
          {this.renderBtns()}
        </Wrapper>
      </BigModalV2>
    )
  }
}

const WarningText = styled.p`
  color: #3e3e3e;
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  max-width: unset;
  padding-left: 16px;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 0 0;
`

const Content = styled.table`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;

  border: 1px solid #ececec;
`

const Link = styled.a`
  color: #1d1e22;
  word-break: break-all;

  &:visited {
    color: #676767;
  }
`

const TableHeader = styled.thead`
  width: 100%;
`

const TableBody = styled.tbody`
  width: 100%;
  flex: 1 0 0;
  align-self: stretch;
  overflow-y: auto;
`

const TopRow = styled.tr`
  width: 100%;
  display: flex;
  align-items: center;
`

const Row = styled.tr`
  display: flex;
  padding: 10px 16px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  border-bottom: 1px solid #ececec;
`

const AdditionalServicesRow = styled.tr`
  display: flex;
  padding: 10px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 6px;
  flex: 1 0 0;
  align-self: stretch;

  > .content {
    display: flex;
    align-items: center;
    align-content: center;
    gap: 4px 12px;
    align-self: stretch;
    flex-wrap: wrap;

    span {
      display: flex;
      padding: 4px 0px;
      justify-content: center;
      align-items: center;
      gap: 4px;

      color: #006736;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
    }
  }
`

const TitleCell = styled.td`
  color: #006736;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
`

const ContentCell = styled.td`
  flex: 1 0 0;
  display: flex;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  width: 50%;

  color: ${({ light }) => (light ? '#676767' : '#1D1E22')};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ light }) => (light ? '600' : '400')};
  line-height: 20px;

  ${({ suffix }) =>
    suffix &&
    `
    font-weight: 700;
  `}

  > span {
    color: #3e3e3e;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
  }
`

const InvoiceCell = styled.td`
  flex: 1 0 0;
  display: flex;
  align-items: center;
  gap: 4px;

  color: #3e3e3e;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ light }) => (light ? '400' : '600')};
  line-height: 20px;
`
const ToggleButton = styled.th`
  display: flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  cursor: pointer;

  background: ${({ active }) => (active ? '#fff' : '#EFEFEF')};

  color: ${({ active }) => (active ? '#1D1E22' : '#3E3E3E')};
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;

  ${({ active }) =>
    active &&
    `
    border-bottom: 2px solid #006736;
  `}
`

const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  align-self: stretch;
`



// WEBPACK FOOTER //
// ./src/components/DetailsModalV2/index.js